import { create } from 'zustand'
import { persist } from 'zustand/middleware'

const useTimerStore = create(
  persist(
    (set) => ({
      activeTimer: null,
      // activeTimer shape: { id, taskId, taskTitle, projectId, projectName, startTime }

      // When this tab last started/stopped a timer itself (see useActiveTimerSync)
      localChangeAt: 0,

      startTimer: (timerData) => set({ activeTimer: timerData, localChangeAt: Date.now() }),

      stopTimer: () => set({ activeTimer: null, localChangeAt: Date.now() }),

      clearTimer: () => set({ activeTimer: null, localChangeAt: Date.now() }),

      syncTimer: (serverData) => {
        if (!serverData) {
          set({ activeTimer: null })
          return
        }
        set({
          activeTimer: {
            id: serverData.id,
            taskId: serverData.task_id,
            taskTitle: serverData.task?.title || '',
            projectId: serverData.task?.project_id || null,
            projectName: serverData.task?.project?.name || '',
            startTime: serverData.start_time
          }
        })
      }
    }),
    {
      name: 'timer-storage'
    }
  )
)

export { useTimerStore }
